namespace Solovis.Reports.Util {

    export class ExcelJsHelper {

        public static setDayIdAsDateInExcelCell(cell, dayId) {
            if (dayId) {
                let date = InvData.DayId.toDate(dayId);
                // Make adjustment to remove time portion of the date that is added in above.
                // TODO: This will need thorough testing and automated test. This could be a quirk of exceljs that could change.
                let date2 = Solovis.Time.getLocalDateFromUtcDate(date);

                cell.value = date2;
            }
            else {
                cell.value = null;
            }
        }

    }

}